import { ToastQueue } from '@adobe/react-spectrum';
import { FPADataTypes } from '../../../infra/protected/FPA/FPAData';
import { invokeFinderApp } from '../../../utils/NavigationUtils';

export function selectedFpaTypeToFinderContextType(type: FPADataTypes): 'FOLDER' | 'PROJECT' | 'ACTIVITY' {
    if (type === FPADataTypes.FOLDER) return 'FOLDER';
    if (type === FPADataTypes.PROJECT) return 'PROJECT';
    return 'ACTIVITY';
}

export interface ContextMoveSuccessToastDeps {
    toastPositive?: (
        message: string,
        options: {
            timeout: number;
            actionLabel: string;
            shouldCloseOnAction: boolean;
            onAction: () => void;
        }
    ) => void;
    openFinderApp?: (contextId: string, contextType: string) => void;
}

export function showContextMoveSuccessToast(
    itemId: number,
    selectedItemType: FPADataTypes,
    message: string,
    actionLabel: string,
    deps: ContextMoveSuccessToastDeps = {}
): void {
    const toastPositive = deps.toastPositive ?? ToastQueue.positive;
    const openFinderApp = deps.openFinderApp ?? invokeFinderApp;
    const contextType = selectedFpaTypeToFinderContextType(selectedItemType);

    toastPositive(message, {
        timeout: 3000,
        actionLabel,
        shouldCloseOnAction: true,
        onAction: () => openFinderApp(itemId + '', contextType),
    });
}
